export const CURRENCIES_FETCH = 'CURRENCIES_FETCH';
export const CURRENCIES_FETCH_ALL = 'CURRENCIES_FETCH_ALL';
export const CURRENCIES_CONVERSION = 'CURRENCIES_CONVERSION';
export const CURRENCIES_IS_FETCING = 'CURRENCIES_IS_FETCING';
export const CURRENCIES_API = 'currencies';
export const CURRENCY_EDIT = 'CURRENCY_EDIT';
export const CURRENCY_SAVE = 'CURRENCY_SAVE';
export const CURRENCY_FILTER = 'CURRENCY_FILTER';


// WEBPACK FOOTER //
// ./src/constants/currencies.js